module.exports = __webpack_public_path__ + "static/media/bg-left-img-2.c83dc045.jpg";